import { z } from "zod"
import { channelResponseSchema } from "../../campaigns/commonTypes"
import {
  GetWidgetConfigurationResponseData,
  IframeChatConfigResponseData,
} from "../widget/response_data"

export const UnauthorizedWidgetConfigurationResponseData = z.object({
  isActive: z.boolean().optional().default(true),
  channel: channelResponseSchema,
  whatsapp: z
    .object({
      phone: z.string(),
      openingMessages: z.record(z.string(), z.string()),
    })
    .optional(),
  company: z.object({ name: z.string(), logo: z.string().nullable().optional() }),
  avoidDeepLink: z.boolean().default(false).optional(),
  displayUrls: z.array(z.string()).default([]),
  webChatConfig: GetWidgetConfigurationResponseData,
  iframeChatConfig: IframeChatConfigResponseData,
})

export const UnauthorizedWidgetStartConversationResponseData = z.object({
  conversationSlug: z.string(),
})
